import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";
import router from "@/router";

export default function useProductsList() {
  // Use toast
  const toast = useToast();

  const refProductListTable = ref(null);
  // Table Handlers

  // 'user_id','model', 'sku', 'mpn','price', 'name', 'description', 'short_description', 'meta_title', 'meta_description', 'meta_keyword', 'image'
  const tableColumns = [
    // { key: "id", label: "ID", sortable: true },
    
    // stickyColumn: true,
    {
      key: "user_id",
      label: "User id",
      sortable: true,
    },
    { key: "image", label: "Image"},
    { key: "category.name", label: "Category"},
    {
      key: "model",
      label: "Model",
      sortable: true,
    },
/*     { key: 'sku', label: 'Sku', sortable: true},
    { key: "mpn", label: "Mpn" , sortable: true}, */
    { key: "price", label: "Price" , sortable: true},
    { key: "name", label: "Name", sortable: true },
    { key: "description", label: "Description", sortable: true },
  /*   { key: 'short_description', label: 'Short Description', sortable: true},
    { key: "meta_title", label: "Meta Title" , sortable: true},
    { key: "meta_description", label: "Meta Description" , sortable: true},
    { key: "meta_keyword", label: "Meta Keyword", sortable: true }, */
    { key: "actions", label: "Action" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const userFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refProductListTable.value
      ? refProductListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refProductListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, userFilter], () => {
    refetchData();
  });

  const userOptions = ref([])
  const categoryOptions = ref([])

  const fetchOptions = () => {
      store
      .dispatch("app/fetchOptions", {
          users: true,
          categories: true
      })
      .then(response => {
          userOptions.value = response.data.users
          categoryOptions.value = response.data.categories
      })
      .catch(() => {
         console.log('Error fetching options')
      })
  }
  
  const productList = ref([]);
  const fetchProducts = (ctx, callback) => {
    let url = "fetchProducts";
    store
      .dispatch(`app-product/${url}`, {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        user_id: userFilter.value
      })
      .then((response) => {
        const { products, total } = response.data;
        products.forEach(ele => ele.price = Math.round(ele.price * 10000) / 10000)
        callback(products);
        productList.value = products;
        totalRow.value = total;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching product list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      })
  };
  
  onMounted(() => {
      fetchOptions()
  })


  return {
    fetchProducts,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refProductListTable,
    ability,
    refetchData,
    productList,
    userOptions,
    userFilter,
    categoryOptions
  };
}
